import styled from "styled-components"

export const StyledAddress = styled.div`
    .new-shipping-address {
        font-size: 20px;
        font-weight: bold;
    }
    .address-autocomplete {
        label {
            font-size: 14px;
            font-weight: bold;
            // text-align: center;
            color: var(--color-primary);
            // font-family: "Raleway", sans-serif;
            // text-transform: uppercase;
            display: flex;
            align-items: center;
            justify-content: space-between;
            @media (max-width: 768px) {
                white-space: nowrap;
            }
        }

        input {
            // padding: 0 !important;
            text-align: left;
            border: 1px solid #ced4da;
            height: calc(1.5em + .75rem + 12px);
            // border-bottom: 1px solid var(--color-primary);
            // &::-webkit-input-placeholder {
            //   font-family: "Raleway", sans-serif;
            // }
        }
        .address-field-header {
            font-size: 14px;
            margin-top: 20px;
            display: flex;
            text-align: left;
            justify-content: space-between;
            align-items: start;
            font-weight: bold;
            span {
                @media (max-width: 768px) {
                    white-space: nowrap;
                }
            }
        }
    }

    .extra-info.height-0 {
        height: 0;
        overflow: hidden;
        max-height: 0;
        opacity: 0;
        margin: 0;
        padding: 0;
        flex-basis: 0;
        display: static;
        transition: opacity 1s ease-in-out;
        transition: max-height 1s ease-in-out;
    }
`
